export default "__VITE_ASSET__cCWInCio__"